import { configureStore } from "@reduxjs/toolkit";
import userProfileReducer from '../slices/userProfileSlice'
import selectedSiteReducer from '../slices/selectedSiteSlice'

export const store = configureStore({
  reducer: {
    userProfile: userProfileReducer,
    selectedSite: selectedSiteReducer,
  },
});

export default store;
